import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';
import { BaseAPIUrl, DefaultWarehouse, FeeId, PostCode, ServiceLocationId } from './fulfillmentApiConstants';

const headers = {
  'Content-Type': 'application/json',
  'Idempotency-Key': 'test',
};

export const getFulfillmentReqObj: RequestOptions = {
  url: `${BaseAPIUrl}/comfulfillmentas/v1/allocations`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getFulfillmentTypesReqObj: RequestOptions = {
  url: `${BaseAPIUrl}/comfulfillmentas/v1/fulfillment-types`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getStoresByFulfillmentTypeReqObj: RequestOptions = {
  url: `${BaseAPIUrl}/comfulfillmentas/v1/cart-pickup-locations`,
  method: HTTPVerbs.POST,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getWarehousesByPostCodeTypeReqObj: RequestOptions = {
  url: `${BaseAPIUrl}/comfulfillmentas/v1/warehouses?postCode=${PostCode}&defaultWarehouse=${DefaultWarehouse}`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const feesReqObj: RequestOptions = {
  url: `/comfulfillmentas/v1/service-fees`,
  method: HTTPVerbs.GET,
  headers,
  retries: 0,
};

export const feeCreationReqObj: RequestOptions = {
  url: `/comfulfillmentas/v1/service-fees`,
  method: HTTPVerbs.POST,
  headers,
  retries: 0,
};

export const feeDeletionReqObj: RequestOptions = {
  url: `/comfulfillmentas/v1/service-fees/${FeeId}`,
  method: HTTPVerbs.DELETE,
  headers,
  retries: 0,
};

export const feeUpdationReqObj: RequestOptions = {
  url: `/comfulfillmentas/v1/service-fees/${FeeId}`,
  method: HTTPVerbs.PUT,
  headers,
  retries: 0,
};

export const getServiceLocationsReqObj: RequestOptions = {
  url: `${BaseAPIUrl}/comfulfillmentas/v1/service-locations`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};

export const getServiceLocationByIdReqObj: RequestOptions = {
  url: `${BaseAPIUrl}/comfulfillmentas/v1/service-locations/${ServiceLocationId}`,
  method: HTTPVerbs.GET,
  headers: {
    ...headers,
  },
  retries: 0,
};
